import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, firstValueFrom } from 'rxjs';
import { DokumentBezeichnungMehDto } from '../../models/base/dokument-bezeichnung-meh-dto.model';
import { UrpKbRequestDto } from '../../models/urp/urp-kb-req-dto.model';
import { ApiService } from '../../services/api.service';

@Injectable({
  providedIn: 'root',
})
export class UrpKbService {
  private _http = inject(HttpClient);
  private _apiService = inject(ApiService);

  public getKbsObservable(
    tagId: number,
    prId: number,
    basId: number,
    lmifId: number,
    regieId: number,
    searchTerm: string,
  ): Observable<DokumentBezeichnungMehDto[]> {
    return this._http.get<DokumentBezeichnungMehDto[]>(
      `${this._apiService.getApiUrl()}/urp/kbs/search?urpTrTagId=${tagId}&prId=${prId}&basId=${basId}&lmifId=${lmifId}&regieId=${regieId}&suchterm=${searchTerm}`,
    );
  }

  public addKbToRapport(
    tagId: number,
    datum: string,
    prId: number,
    basId: number,
    lmifId: number,
    regieId: number,
    kbId: number,
    codeIds: number[],
    lieferscheinId: number,
  ) {
    const urpKbRequestDto = new UrpKbRequestDto();
    urpKbRequestDto.urpTrTagId = tagId;
    urpKbRequestDto.datum = datum;
    urpKbRequestDto.prId = prId;
    urpKbRequestDto.basId = basId;
    urpKbRequestDto.lmifId = lmifId;
    urpKbRequestDto.regieId = regieId;
    urpKbRequestDto.kbId = kbId;
    urpKbRequestDto.codeIds = codeIds;
    urpKbRequestDto.lieferscheinId = lieferscheinId;

    return firstValueFrom(this._http.post(`${this._apiService.getApiUrl()}/urp/kbs`, urpKbRequestDto));
  }

  public deleteKbFromRapport(tagId: number, prId: number, basId: number, regieId: number, kbId: number) {
    return firstValueFrom(
      this._http.delete(
        `${this._apiService.getApiUrl()}/urp/kbs/${kbId}?urpTrTagId=${tagId}&prId=${prId}&basId=${basId}&regieId=${regieId}`,
      ),
    );
  }

  public refreshKbs() {
    return firstValueFrom(this._http.get(`${this._apiService.getApiUrl()}/urp/kbs/refresh`));
  }
}
